<template>
    <div class="body">
        <div class="list">
            <div class="item" v-for="(item,index) in list" :key="index" @click="$router.push({ path: '/simultaneousInterpretationInfo', query: { id: item.id,type:item.type }})">
                <div class="i_top">{{item.createTime}}记录</div>
                <div class="i_bottom line2_">{{item.transText}}</div>
            </div>
            <el-empty description="暂无数据" v-if="list.length == 0" />
        </div>
    </div>
</template>

<script>
import {
    transRecordList
} from '@/apis/index'
export default {
    data() {
        return {
            pageNum: 1,
            total: 0,
            list: []
        }
    },
    mounted() {
        this.getList()
    },
    methods: {
        getList() {
            transRecordList(this.pageNum).then(res => {
                console.log(res)
                this.list = res.data
            })
        }
    }
}
</script>

<style lang="scss" scoped>
.line1_ {
    word-break: break-all;
    display: -webkit-box;
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
}

.line2_ {
    word-break: break-all;
    display: -webkit-box;
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
}

.body {
    width: 860px;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;

    .list::-webkit-scrollbar {
        display: none;
    }

    .list {
        width: 100%;
        height: 0;
        flex: 1;
        margin-top: 30px;
        overflow-y: scroll;

        .item {
            width: 100%;
            background: #FFFFFF;
            border-radius: 12px 12px 12px 12px;
            border: 1px solid #E9EBF2;
            box-sizing: border-box;
            padding: 10px;
            margin-bottom: 20px;
            cursor: pointer;

            .i_top {
                font-weight: bold;
                font-size: 20px;
                color: #000000;
            }

            .i_bottom {
                width: 100%;
                font-weight: 400;
                font-size: 16px;
                color: #1D1C21;
                line-height: 24px;
                margin-top: 20px;

            }
        }
    }
}
</style>